<template>
  <div class="request-page">
    <div class="request-container">
      <div class="request-card">
        <div class="header">
          <router-link to="/login" class="back-link">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M19 12H5M12 19l-7-7 7-7"/>
            </svg>
            Back to login
          </router-link>
          <h2>Reset Password</h2>
          <p>Submit a request to the IT Admin to reset your password.</p>
        </div>

        <form @submit.prevent="handleSubmit" v-if="!submitted">
          <div class="input-group">
            <label>Username</label>
            <input type="text" v-model="form.username" required placeholder="Enter your username" />
          </div>
          <div class="input-group">
            <label>Official Email (Email Kantor)</label>
            <input type="email" v-model="form.email_kantor" required placeholder="your.name@company.com" />
          </div>

          <div class="info-box">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="16" x2="12" y2="12"></line>
              <line x1="12" y1="8" x2="12.01" y2="8"></line>
            </svg>
            <p>Admin akan mereset password Anda ke <strong>password123</strong> dan menginfokan via email kantor Anda.</p>
          </div>

          <button type="submit" class="submit-btn" :disabled="loading">
            <span v-if="!loading">Request Reset</span>
            <div v-else class="spinner"></div>
          </button>

          <p v-if="error" class="error-msg">{{ error }}</p>
        </form>

        <div v-else class="success-state">
          <div class="success-icon">✓</div>
          <h3>Request Submitted!</h3>
          <p>Permintaan reset sudah dikirim. Silakan cek email kantor Anda secara berkala untuk konfirmasi dari Admin IT.</p>
          <router-link to="/login" class="login-btn">Return to Login</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive } from 'vue'
import axios from 'axios'

const API_URL = (import.meta.env.VITE_API_URL || 'https://it-ticketing-api.maulanarofiq72.workers.dev').replace(/\/$/, '')

const form = reactive({
  username: '',
  email_kantor: ''
})

const loading = ref(false)
const submitted = ref(false)
const error = ref('')

const handleSubmit = async () => {
  loading.value = true
  error.value = ''
  try {
    await axios.post(`${API_URL}/request-reset`, form)
    submitted.value = true
  } catch (err: any) {
    error.value = err.response?.data?.detail || 'Failed to submit request. Please try again.'
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.request-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f4f5f7;
  padding: 2rem;
}
.request-container {
  width: 100%;
  max-width: 440px;
}
.request-card {
  background: white;
  padding: 2.5rem;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(9, 30, 66, 0.08);
}
.header {
  margin-bottom: 2rem;
}
.back-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #0052cc;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.9rem;
  margin-bottom: 1.5rem;
}
h2 {
  font-size: 1.8rem;
  color: #172b4d;
  margin-bottom: 0.5rem;
}
p {
  color: #5e6c84;
}
.input-group {
  margin-bottom: 1.5rem;
}
label {
  display: block;
  font-size: 0.9rem;
  font-weight: 600;
  color: #5e6c84;
  margin-bottom: 0.5rem;
}
input {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid #dfe1e6;
  border-radius: 8px;
  font-size: 1rem;
}
.info-box {
  background-color: #deebff;
  padding: 1rem;
  border-radius: 8px;
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  margin-bottom: 1.5rem;
}
.info-box svg {
  color: #0052cc;
  flex-shrink: 0;
  margin-top: 3px;
}
.info-box p {
  color: #0747a6;
  font-size: 0.85rem;
  margin: 0;
  line-height: 1.4;
}
.submit-btn {
  width: 100%;
  padding: 0.9rem;
  background-color: #0052cc;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
}
.success-state {
  text-align: center;
}
.success-icon {
  width: 64px;
  height: 64px;
  background: #e3fcef;
  color: #006644;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  margin: 0 auto 1.5rem;
}
.login-btn {
  display: inline-block;
  margin-top: 2rem;
  padding: 0.75rem 2rem;
  background: #0052cc;
  color: white;
  text-decoration: none;
  border-radius: 8px;
  font-weight: 600;
}
.spinner {
  width: 20px;
  height: 20px;
  border: 3px solid rgba(255,255,255,0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 0.8s linear infinite;
  margin: 0 auto;
}
@keyframes spin { to { transform: rotate(360deg); } }
</style>
